export enum HealthMonitorGridAccessor {
  PC_NAME = "pcName",
  LOCATION_NAME = "locationName",
  STATUS = "status",
  UP_DOWN_TIME = "upDownTime",
  DEVICE_TYPE = "deviceTypeEnum",
  WARNINGS = "warnings",
}
